import ChatCard from "components/DesignSystem/ChatCard/ChatCard";
import { Button } from "components/DesignSystem/Button/Button";
import { ChatCartPaid } from "components/icons/Chat/ChatCartPaid";
import { CustomerFeedback } from "types/Models/reviewDocumentAndBalancingPayment";
import { CustomerFeedbackCardHeader } from "./CustomerFeedbackCardHeader";

type RecordedCustomerFeedbackCloseViewProps = {
  feedback: CustomerFeedback;
  header: string;
  size?: "regular" | "block";
  setExpanded: (expanded: boolean) => void;
};

export const RecordedCustomerFeedbackCloseView = ({
  feedback,
  header,
  size = "regular",
  setExpanded,
}: RecordedCustomerFeedbackCloseViewProps) => (
  <ChatCard.Root size={size}>
    <ChatCard.Header>
      <CustomerFeedbackCardHeader isSubmitted header={header} />
    </ChatCard.Header>
    <ChatCard.Body>
      <div className="t-flex t-flex-col t-gap-3">
        <div className="t-space-y-1">
          <div className="t-text-body-sm t-text-text-30">
            {feedback.feedback_for}
          </div>
          <div className="t-text-text-100 t-text-subtext-sm">
            {feedback.name}
          </div>
        </div>
        <Button
          type="button"
          size="small"
          block
          onClick={() => setExpanded(true)}
        >
          View feedback
        </Button>
      </div>
    </ChatCard.Body>
  </ChatCard.Root>
);
